import React from 'react';
import Modal from './Modal';
import Button from './Button';

interface SelecaoFilialModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFilialSelected: (filial: string) => void;
  filiaisDisponiveis: string[];
}

const filiais = [
  { id: 'FILIAL_1', nome: 'Filial 1 - UP Distribuidora', observacao: '', logo: '/Filial 1- UP DISTRIBUIDORA.png' },
  { id: 'FILIAL_2', nome: 'Filial 2 - Aleplast', observacao: '', logo: '/Filial 2- Aleplast.png' },
  { id: 'FILIAL_3', nome: 'Filial 3 - Alepack', observacao: 'Ainda inoperante', logo: '' }
];

const SelecaoFilialModal: React.FC<SelecaoFilialModalProps> = ({
  isOpen,
  onClose,
  onFilialSelected,
  filiaisDisponiveis
}) => {
  const handleFilialClick = (filialId: string) => {
    onFilialSelected(filialId);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Selecionar Filial" size="md">
      <div className="space-y-4">
        <p className="text-sm text-gray-600">
          Onde você quer agendar?
        </p>

        <div className="space-y-3">
          {filiais
            .filter(f => filiaisDisponiveis.includes(f.id))
            .map((filial) => (
              <button
                key={filial.id}
                onClick={() => handleFilialClick(filial.id)}
                className="w-full p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors text-left"
              >
                <div className="flex justify-between items-start">
                  <div className="flex items-center gap-4">
                    {filial.logo && (
                      <img
                        src={filial.logo}
                        alt={filial.nome}
                        className="w-12 h-12 object-contain"
                        onError={(e) => {
                          (e.target as HTMLImageElement).style.display = 'none';
                        }}
                      />
                    )}
                    <div>
                      <p className="font-medium text-gray-900">{filial.nome}</p>
                      {filial.observacao && (
                        <p className="text-xs text-orange-600 mt-1 font-medium">
                          ⚠️ {filial.observacao}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="text-blue-600">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </button>
            ))}
        </div>

        <div className="pt-4 border-t">
          <p className="text-xs text-gray-500">
            Você poderá alterar a filial a qualquer momento usando o seletor no topo da tela.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default SelecaoFilialModal;
